<template>
  <div class="view-request-wrapper">
    <div class="sticky-header">
      <a-tabs type="card" v-model="activeTab" @change="handleTabChange" class="request-tabs">
        <a-tab-pane key="flexible">
          <span slot="tab" class="tab-title">
            <a-icon type="swap" /> Flexible Day
          </span>
        </a-tab-pane>
        <a-tab-pane key="leave">
          <span slot="tab" class="tab-title">
            <a-icon type="schedule" /> Leave of Absent
          </span>
        </a-tab-pane>
        <a-tab-pane key="wfh">
          <span slot="tab" class="tab-title">
            <a-icon type="home" /> Work From Home
          </span>
        </a-tab-pane>
        <a-tab-pane key="seminar">
          <span slot="tab" class="tab-title">
            <a-icon type="reconciliation" /> Seminar
          </span>
        </a-tab-pane>
        <a-tab-pane key="time">
          <span slot="tab" class="tab-title">
            <a-icon type="clock-circle" /> Time Absent
          </span>
        </a-tab-pane>
      </a-tabs>
      <div class="filter-wrapper">
        <a-range-picker 
          v-model="dateRange" 
          @change="handleDateChange" 
          :allow-clear="false"
          class="range-picker-centered"
        />
      </div>
    </div>

    <div class="list-container">
      <a-spin :spinning="loading" :tip="loadingTip">
        <a-list
          class="request-list-view"
          item-layout="horizontal"
          :data-source="dataList"
        >
          <a-list-item slot="renderItem" slot-scope="item">
            <template slot="actions">
               <a-tag :color="getStatusColor(item.status)">{{ item.status.toUpperCase() }}</a-tag>
               <a-popconfirm
                 v-if="item.status === 'wait'"
                 title="Are you sure you want to delete this request?"
                 @confirm="handleDelete(item)"
                 ok-text="Yes"
                 cancel-text="No"
               >
                 <a-button type="danger" shape="circle" icon="delete" size="small" />
               </a-popconfirm>
            </template>
            <a-list-item-meta>
              <template slot="title">
                <span class="font-weight-bold">{{ item.title }}</span>
              </template>
              <template slot="description">
                <div class="request-subtitle" v-html="item.subtitle"></div>
              </template>
              <a-avatar
                slot="avatar"
                :icon="item.icon"
                :style="{ backgroundColor: '#1a1a2e' }"
              />
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-spin>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      activeTab: 'flexible',
      dataList: [],
      loading: false,
      moment,
      dateRange: [moment().subtract(3, 'months').startOf('month'), moment().endOf('month')]
    };
  },
  computed: {
    loadingTip() {
      if (!this.dateRange || this.dateRange.length < 2) return "กำลังเรียกข้อมูล...";
      const start = this.dateRange[0].clone().add(543, 'year').locale('th').format('DD/MM/YYYY');
      const end = this.dateRange[1].clone().add(543, 'year').locale('th').format('DD/MM/YYYY');
      return `กำลังเรียกข้อมูลช่วงวันที่ ${start} - ${end}`;
    }
  },
  mounted() {
    this.fetchRequests();
  },
  methods: {
    handleTabChange() {
      this.fetchRequests();
    },
    handleDateChange() {
      this.fetchRequests();
    },
    async fetchRequests() {
      this.loading = true;
      this.dataList = [];
      const start = this.dateRange[0].format('YYYY-MM-DD');
      const end = this.dateRange[1].format('YYYY-MM-DD');
      const formatThai = (d) => `<b>${moment(d).add(543, 'year').locale('th').format('DD/MM/YYYY')}</b>`;

      const config = {
        flexible: {
          url: `/hri/flexible-day/me/?start=${start}&end=${end}`,
          map: item => ({
            title: 'Flexible Day',
            subtitle: `${formatThai(item.selected_date)} แลกกับ ${formatThai(item.move_to_date)}`,
            status: item.status,
            id: item.id,
            type: 'flex',
            icon: 'swap'
          })
        },
        leave: {
          url: `/hri/leave_of_absence/?timestart=${start}&timeend=${end}`,
          map: item => ({
            title: item.absence_type ? (item.absence_type.charAt(0).toUpperCase() + item.absence_type.slice(1)) : 'Leave Request',
            subtitle: `${formatThai(item.start_date)} ถึง ${formatThai(item.end_date)} รวมลา <b>${item.absence_amount}</b> วัน`,
            status: item.status,
            id: item.id,
            type: 'leave',
            icon: 'schedule'
          })
        },
        wfh: {
          url: `/hri/workfromhome/me/?start=${start}&end=${end}`,
          map: item => ({
            title: 'Work From Home',
            subtitle: `วันที่ ${formatThai(item.selected_date)}`,
            status: item.status,
            id: item.id,
            type: 'home',
            icon: 'home'
          })
        },
        time: {
          url: `/hri/time-request/?timestart=${start}&timeend=${end}`,
          map: item => {
            const startTime = item.start_time ? moment(item.start_time).format('HH:mm') : '-';
            const endTime = item.end_time ? moment(item.end_time).format('HH:mm') : '-';
            const displayDate = item.start_time || item.end_time || null;
            return {
              title: 'Time Absent',
              subtitle: `วันที่ ${displayDate ? formatThai(displayDate) : '-'} เวลา ${startTime} - ${endTime}`,
              status: item.status,
              id: item.id,
              type: 'time',
              icon: 'clock-circle'
            };
          }
        },
        seminar: {
          url: `/hri/seminar-request/?timestart=${start}&timeend=${end}`,
          map: item => ({
            title: `Seminar Type ${item.seminar_type || '-'}`,
            subtitle: `${formatThai(item.start_date)} ถึง ${formatThai(item.end_date)} รวม <b>${item.seminar_amount}</b> วัน`,
            status: item.status,
            id: item.id,
            type: 'serminar',
            icon: 'reconciliation'
          })
        }
      };

      try {
        const target = config[this.activeTab];
        if (!target) return;
        
        const res = await this.$http.get(target.url);
        if (res.status === 200 && Array.isArray(res.data)) {
          this.dataList = res.data.map(target.map);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching requests:", error);
      } finally {
        this.loading = false;
      }
    },
    getStatusColor(status) {
      const colors = {
        wait: 'orange',
        approve: 'green',
        reject: 'red',
        cancel: 'gray'
      };
      return colors[status] || 'blue';
    },
    async handleDelete(item) {
      const paths = {
        'leave': `/hri/leave_of_absence/${item.id}/remove/`,
        'flex': `/hri/flexible-day/${item.id}/remove/`,
        'serminar': `/hri/seminar-request/${item.id}/remove/`,
        'time': `/hri/time-request/${item.id}/remove/`,
        'home': `/hri/workfromhome/${item.id}/remove/`
      };

      const url = paths[item.type];
      if (!url) {
        this.$message.error('Invalid request type');
        return;
      }

      this.loading = true;
      try {
        const res = await this.$http.delete(url);
        if (res.status === 200 || res.data.success) {
          this.$message.success('Request deleted successfully');
          this.fetchRequests();
        } else {
          this.$message.error(res.data.message || 'Failed to delete request');
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error deleting request:", error);
        this.$message.error('An error occurred while deleting the request');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.sticky-header {
  position: sticky;
  top: -24px;
  z-index: 100;
  background: #fff;
  padding: 10px 0;
  margin-top: -24px;
  margin-bottom: 5px;
  border-bottom: 1px solid #f0f0f0;
}
.tab-title {
  font-weight: bold;
  color: #000;
}
::v-deep .ant-tabs-nav-scroll {
  text-align: center;
}
::v-deep .ant-tabs-nav {
  float: none;
  display: inline-block;
}
.filter-wrapper {
  display: flex;
  justify-content: center;
  padding: 5px 0 10px;
}
.range-picker-centered {
  width: 280px;
}
.list-container {
  padding: 0 16px;
}
.request-list-view {
  min-height: 200px;
  margin-bottom: 100px;
}
::v-deep .ant-spin-nested-loading {
  width: 100%;
}
::v-deep .ant-spin-container::after {
  background: rgba(255, 255, 255, 0.7);
}
::v-deep .ant-spin {
  max-height: 400px;
  top: 100px;
}
.font-weight-bold {
  font-weight: bold;
  color: #1a1a2e;
}
.request-subtitle {
  font-size: 13px;
  color: #595959;
}
</style>
